import { useEffect, useRef, useState } from "react";
import { Play, Pause } from "lucide-react";

export default function WorkVideo({ site }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) el.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
      else { el.pause(); setPlaying(false); }
    }, { threshold: 0.35 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const toggle = () => {
    const el = ref.current;
    if (!el) return;
    if (el.paused) el.play().then(() => setPlaying(true)).catch(() => {});
    else { el.pause(); setPlaying(false); }
  };

  return (
    <div className="rounded-2xl overflow-hidden min-w-0 border border-[#E8DCCB] shadow-[0_8px_32px_rgba(58,46,37,0.12)] transition-transform duration-500 hover:-translate-y-2 group bg-[#FFFDF7]"
      data-testid={`work-${site.id}`}>
      <div className="flex items-center gap-2 px-4 py-2.5 border-b bg-[#FAF6EF] border-[#E8DCCB]">
        <span className="w-2.5 h-2.5 rounded-full bg-[#A8785A]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#C39B7B]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#C48A9F]" />
        <span className="ml-3 text-[10px] tracking-[0.12em] rounded-full px-3 py-1 text-[#8C7562] bg-[#F3EAE0]">{site.url}</span>
      </div>
      <div className="relative bg-[#F3EAE0]">
        <video ref={ref} src={site.video} poster={site.poster} muted loop playsInline preload="metadata"
          className="w-full block object-contain" style={{ aspectRatio: site.aspect || "16 / 9" }} data-testid={`work-video-${site.id}`} />
        <button onClick={toggle} aria-label={playing ? "Pause" : "Play"} data-testid={`work-toggle-${site.id}`}
          className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-[#FFFDF7]/90 border border-[#E8DCCB] flex items-center justify-center text-[#3A2E25] opacity-0 group-hover:opacity-100 transition-opacity">
          {playing ? <Pause size={14} /> : <Play size={14} />}
        </button>
      </div>
    </div>
  );
}
